
/* RUBICSTONE WISHLIST - COMPLETE JS */

const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectorswish = {
  button: '[button-wishlist], .rubic-heart[data-product-handle]',
  grid: '[grid-wishlist]',
  productCard: '.grid__item'
};

/* WISHLIST STORAGE */

const getWishlist = () => {
  try {
    return [...new Set(
      (localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || '')
        .split(LOCAL_STORAGE_DELIMITER)
        .filter(Boolean)
    )];
  } catch (error) {
    console.error('[Wishlist] Storage error:', error);
    return [];
  }
};

const wishlistContains = (handle) => {
  return getWishlist().includes(handle);
};

/* BOTTOM RIGHT POPUP */

let wishlistToastTimer;

function showWishlistAlert(type) {
  const messages = {
    added: [
      'Added to Wishlist!',
      'Product saved successfully.',
      'success'
    ],
    removed: [
      'Removed from Wishlist!',
      'Product removed successfully.',
      'info'
    ],
    moved: [
      'Added to Cart!',
      'Product moved from wishlist to cart.',
      'success'
    ]
  };

  const message = messages[type];
  if (!message) return;

  if (window.Swal && typeof window.Swal.fire === 'function') {
    window.Swal.fire({
      toast: true,
      position: 'bottom-end',
      icon: message[2],
      title: message[0],
      text: message[1],
      showConfirmButton: false,
      showCloseButton: true,
      timer: 2000,
      timerProgressBar: true,
      backdrop: false
    });
    return;
  }

  let toast = document.getElementById('rubic-wishlist-toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'rubic-wishlist-toast';

    Object.assign(toast.style, {
      position: 'fixed',
      right: '20px',
      bottom: '20px',
      zIndex: '999999',
      background: '#fff',
      color: '#292323',
      padding: '15px 20px',
      borderRadius: '12px',
      boxShadow: '0 8px 30px rgba(0,0,0,.17)',
      fontSize: '14px',
      maxWidth: '330px',
      transition: 'opacity .2s'
    });

    document.body.appendChild(toast);
  }

  toast.textContent = message[0] + ' ' + message[1];
  toast.style.opacity = '1';

  clearTimeout(wishlistToastTimer);

  wishlistToastTimer = setTimeout(() => {
    toast.style.opacity = '0';
  }, 2000);
}

/* UPDATE COUNT */

const updateWishlistCount = () => {
  const count = getWishlist().length;

  document.querySelectorAll('[data-js-wishlist-count]')
    .forEach((element) => {
      element.setAttribute('data-js-wishlist-count', count);
      element.textContent = count;
    });

  document.querySelectorAll('.wishlist-text')
    .forEach((element) => {
      element.style.display = count ? 'none' : 'block';
    });
};

/* SYNC HEART BUTTONS */

const syncWishlistButtons = () => {
  const handles = new Set(getWishlist());

  document.querySelectorAll(selectorswish.button)
    .forEach((button) => {
      const handle = button.dataset.productHandle;
      if (!handle) return;

      const selected = handles.has(handle);

      button.classList.toggle(BUTTON_ACTIVE_CLASS, selected);
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
};

/* SAVE WISHLIST */

const setWishlist = (items) => {
  const wishlist = [...new Set(items.filter(Boolean))];

  try {
    if (wishlist.length) {
      localStorage.setItem(
        LOCAL_STORAGE_WISHLIST_KEY,
        wishlist.join(LOCAL_STORAGE_DELIMITER)
      );
    } else {
      localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    }
  } catch (error) {
    console.error('[Wishlist] Save failed:', error);
    return false;
  }

  syncWishlistButtons();
  updateWishlistCount();

  document.dispatchEvent(
    new CustomEvent('shopify-wishlist:updated', {
      detail: { wishlist }
    })
  );

  return true;
};

/* ADD OR REMOVE WISHLIST */

const updateWishlist = (handle) => {
  if (!handle) return false;

  const wishlist = getWishlist();
  const exists = wishlist.includes(handle);

  const saved = setWishlist(
    exists
      ? wishlist.filter((item) => item !== handle)
      : [...wishlist, handle]
  );

  if (saved) {
    showWishlistAlert(exists ? 'removed' : 'added');
  }

  return saved;
};

const resetWishlist = () => setWishlist([]);

/* INITIALIZE HEART BUTTONS */

const initButtons = () => {
  syncWishlistButtons();

  document.dispatchEvent(
    new CustomEvent('shopify-wishlist:init-buttons', {
      detail: { wishlist: getWishlist() }
    })
  );
};

/* FETCH WISHLIST PRODUCT CARD */

const fetchProductCardHTML = async (handle) => {
  try {
    const response = await fetch(
      `/products/${encodeURIComponent(handle)}?view=wish`
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const html = new DOMParser().parseFromString(
      await response.text(),
      'text/html'
    );

    const card = html.querySelector(selectorswish.productCard);

    if (!card) {
      throw new Error('Wishlist product card not found');
    }

    return card.outerHTML;
  } catch (error) {
    console.error('[Wishlist] Product load failed:', handle, error);
    return '';
  }
};

/* RENDER WISHLIST GRID */

let wishlistGridRequest = 0;

const setupGrid = async (grid) => {
  const requestId = ++wishlistGridRequest;
  const wishlist = getWishlist();

  if (!wishlist.length) {
    grid.innerHTML = '';
    grid.classList.add(GRID_LOADED_CLASS);
    updateWishlistCount();
    return;
  }

  const cards = await Promise.all(
    wishlist.map(fetchProductCardHTML)
  );

  if (requestId !== wishlistGridRequest) return;

  grid.innerHTML = cards.filter(Boolean).join('');
  grid.classList.add(GRID_LOADED_CLASS);

  initButtons();
  updateWishlistCount();

  document.dispatchEvent(
    new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist }
    })
  );
};

const initGrid = () => {
  const grid = document.querySelector(selectorswish.grid);
  if (grid) setupGrid(grid);
};

/* ==========================================
   CART SUCCESS DETECTION
   ========================================== */

const pendingWishlistAdds = [];
const CART_PENDING_MS = 15000;

const cartAddURL = (url) => {
  try {
    const pathname = new URL(url, location.href).pathname;
    return /\/cart\/add(?:\.js)?\/?$/.test(pathname);
  } catch (error) {
    return false;
  }
};

function parseVariantId(body) {
  try {
    if (body instanceof FormData ||
        body instanceof URLSearchParams) {
      return String(body.get('id') || '');
    }

    if (typeof body === 'string') {
      const value = body.trim();

      if (value.startsWith('{')) {
        const json = JSON.parse(value);
        return String(
          json.id || json.items?.[0]?.id || ''
        );
      }

      return String(
        new URLSearchParams(value).get('id') || ''
      );
    }
  } catch (error) {
    // Ignore unrecognized body
  }

  return '';
}

/* TRACK WISHLIST ADD TO CART */

function queueWishlistCartAdd(form) {
  const card = form.closest('.grid__item');

  const handle =
    card?.querySelector('[data-product-handle]')
      ?.dataset.productHandle ||
    card?.dataset.productHandle;

  const variantId = String(
    form.querySelector('[name="id"]')?.value || ''
  );

  if (!handle || !variantId || !wishlistContains(handle)) {
    return;
  }

  pendingWishlistAdds.push({
    handle,
    variantId,
    time: Date.now()
  });
}

function takePendingAdd(variantId) {
  const now = Date.now();

  for (let i = pendingWishlistAdds.length - 1; i >= 0; i--) {
    if (now - pendingWishlistAdds[i].time > CART_PENDING_MS) {
      pendingWishlistAdds.splice(i, 1);
    }
  }

  const index = pendingWishlistAdds.findIndex(
    (item) => item.variantId === String(variantId)
  );

  return index < 0
    ? null
    : pendingWishlistAdds.splice(index, 1)[0];
}

/* REMOVE ONLY AFTER SUCCESS */

function confirmWishlistCartAdd(variantId) {
  const pending = takePendingAdd(variantId);

  if (!pending || !wishlistContains(pending.handle)) {
    return;
  }

  const saved = setWishlist(
    getWishlist().filter(
      (item) => item !== pending.handle
    )
  );

  if (saved) {
    showWishlistAlert('moved');
  }
}

/* CAPTURE WISHLIST FORM SUBMIT */

document.addEventListener('submit', (event) => {
  const form = event.target;

  if (
    form instanceof HTMLFormElement &&
    form.closest('[grid-wishlist]') &&
    cartAddURL(form.action)
  ) {
    queueWishlistCartAdd(form);
  }
}, true);

/* FETCH AJAX CART DETECTION */

if (!window.__rubicWishlistFetchPatched) {
  window.__rubicWishlistFetchPatched = true;

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const request = args[0];
    const options = args[1] || {};

    const url =
      typeof request === 'string' || request instanceof URL
        ? request
        : request?.url;

    const isAdd = url && cartAddURL(url);

    const variantId = parseVariantId(options.body);

    const result = originalFetch.apply(this, args);

    if (!isAdd) return result;

    return result.then((response) => {
      if (response.ok) {
        response.clone().json().then((data) => {
          if (data?.status >= 400 || data?.errors) return;

          const variant =
            variantId ||
            String(
              data?.id ||
              data?.items?.[0]?.id ||
              ''
            );

          if (variant) {
            confirmWishlistCartAdd(variant);
          }
        }).catch(() => {});
      }

      return response;
    });
  };
}

/* XMLHTTPREQUEST CART DETECTION */

if (!XMLHttpRequest.prototype.__rubicWishlistPatched) {
  XMLHttpRequest.prototype.__rubicWishlistPatched = true;

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (
    method,
    url,
    ...args
  ) {
    this.__rubicCartAdd =
      cartAddURL(url) &&
      String(method).toUpperCase() === 'POST';

    return originalOpen.call(this, method, url, ...args);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this.__rubicCartAdd) {
      const variantId = parseVariantId(body);

      this.addEventListener('load', () => {
        if (this.status < 200 || this.status >= 300) {
          return;
        }

        try {
          const data = JSON.parse(this.responseText);

          if (data?.status >= 400 || data?.errors) return;

          const variant =
            variantId ||
            String(
              data?.id ||
              data?.items?.[0]?.id ||
              ''
            );

          if (variant) {
            confirmWishlistCartAdd(variant);
          }
        } catch (error) {
          // Ignore non-JSON response
        }
      }, { once: true });
    }

    return originalSend.call(this, body);
  };
}

/* WISHLIST HEART CLICK */

document.addEventListener('click', (event) => {
  const button = event.target.closest(
    selectorswish.button
  );

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const handle = button.dataset.productHandle;

  if (handle) {
    updateWishlist(handle);
  } else {
    console.error(
      '[Wishlist] Missing data-product-handle'
    );
  }
}, true);

/* INITIALIZE */

const initializeWishlist = () => {
  initButtons();
  initGrid();
  updateWishlistCount();
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeWishlist
  );
} else {
  initializeWishlist();
}

/* REFRESH GRID AFTER WISHLIST CHANGE */

document.addEventListener(
  'shopify-wishlist:updated',
  initGrid
);

/* SHOPIFY SECTION RELOAD */

document.addEventListener(
  'shopify:section:load',
  initializeWishlist
);

/* SYNC BETWEEN TABS */

window.addEventListener('storage', (event) => {
  if (event.key === LOCAL_STORAGE_WISHLIST_KEY) {
    syncWishlistButtons();
    updateWishlistCount();
    initGrid();
  }
});

/* INFINITE SCROLL SUPPORT */

const observeWishlistButtons = () => {
  if (!document.body) return;

  new MutationObserver((mutations) => {
    const hasNewButtons = mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) =>
        node.nodeType === 1 &&
        (
          node.matches?.(selectorswish.button) ||
          node.querySelector?.(selectorswish.button)
        )
      )
    );

    if (hasNewButtons) {
      syncWishlistButtons();
    }
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    observeWishlistButtons
  );
} else {
  observeWishlistButtons();
}
